<script setup>
  import { ref, onBeforeMount, computed } from "vue";
  import { useCompanyStore } from "@/stores/company";
  import { useUiStore } from "@/stores/ui";
  import { useDevicesStore } from "@/stores/devices";

  const emit = defineEmits(['refresh']);
  const uiStore = useUiStore();
  const devicesStore = useDevicesStore();
  let name = ref(null);
  let mac_address = ref(null);
  const company_id = useCompanyStore().companyId;
  const getModalInfo = computed(()=> uiStore.modalData);
  const getModalAction = computed(()=> uiStore.modalAction);

  let isSubmitted = ref(false);

  // const global_user_name = inject(['global_user_name']);
  const user = ref(JSON.parse(localStorage.getItem("userDetails")));

  const onSubmit = () => {
    isSubmitted.value = true;
    let data = {
      entityId: company_id,
      kioskName : name.value,
      macAddress : mac_address.value,
      userName : user.value.first_name+' '+ user.value.last_name,
      userId : user.value.user_id,
      connectionType : 'daemon',
    }

    devicesStore.openDoor(data)
    .then(() => {
      resetStoreData();
      emit('refresh');
    })
    .catch(() => {
      isSubmitted.value = false;
    });
  };

  const resetStoreData = () =>{
    uiStore.resetModalStore();
  };

  onBeforeMount(()=>{
    if(getModalInfo.value && getModalInfo.value.data_type == 'device' && getModalAction.value == 'open_door'){
      name.value = getModalInfo.value.name;
      mac_address.value = getModalInfo.value.mac_address;
    }
  });
</script>

<template>
  <DModal v-if="getModalAction === 'open_door'" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Open Door </template>

    <template #body>
      <div class="delete-text">
        <span>Are you sure you want to <b>"Open"</b> the door connected to the device "{{ name }}" ?</span>
      </div>
    </template>

    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button :disabled="isSubmitted" 
          @click="onSubmit" type="button" class="btn btn-primary add-button mr-30">
            Open <span v-if="isSubmitted"  class="spinner-sm" role="status" aria-hidden="true" ></span>
          </button>
          <button @click="resetStoreData" type="button" class="btn btn-secondary cancel-button">Cancel</button>
        </div>
      </div>
    </template>
  </DModal>
</template>
  